import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        formSubmission: '='
    },
    template: `
        <div class="quiz-results">
            <p class="msg01 msg-ok">{{ 'evaluation.Feedback submitted successfully. Thank you for the answers.' | translate }}</p>
        </div>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/public/evaluation/finished/index.js